import { UsersSelectionWidget, VehicleSelectionWidget } from 'components/FormWidgets';

const uiSchema = (taskType) => ({
  'ui:order': ['tariff', 'vehicle_id', 'loader_id', 'start_time', 'start_date', '*'],
  tariff: {
    'ui:field': 'tariff',
    'ui:options': {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
    },
  },
  // tariff_id: {
  //   'ui:widget': TariffSelectionWidget,
  //   'ui:options': {
  //     xs: 12,
  //     sm: 12,
  //     md: 12,
  //     lg: 12,
  //     xl: 12,
  //   },
  // },
  vehicle_id: {
    'ui:widget': VehicleSelectionWidget,
    'ui:options': {
      initFilter: { taskType },
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
    },
  },
  loader_id: {
    'ui:disabled': ['1', '14'].includes(taskType) ? false : true,
    'ui:widget': VehicleSelectionWidget,
    'ui:options': {
      initFilter: { type_ids: ['3', '4'] },
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
    },
  },
  start_time: {
    'ui:options': {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 6,
      xl: 6,
    },
  },
  start_date: {
    'ui:options': {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 6,
      xl: 6,
    },
  },
  supervisor_id: {
    'ui:widget': UsersSelectionWidget,
    'ui:options': {
      initFilter: { role_id: '8' },
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
    },
  },
  tonnage: {
    'ui:options': {
      xs: 6,
      sm: 6,
      md: 6,
      lg: 6,
      xl: 6,
    },
  },
  coefficient: {
    'ui:options': {
      xs: 6,
      sm: 6,
      md: 6,
      lg: 6,
      xl: 6,
    },
  },
  bill_number: {
    'ui:options': {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
    },
  },
  description: {
    'ui:widget': 'textarea',
    'ui:options': {
      rows: 10,
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
    },
  },
});

export default uiSchema;
